import { render, staticRenderFns } from "./ItemSeminaire.vue?vue&type=template&id=bcf7f4f2&"
import script from "./ItemSeminaire.vue?vue&type=script&lang=js&"
export * from "./ItemSeminaire.vue?vue&type=script&lang=js&"
import style0 from "./ItemSeminaire.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports